var url = ''
if (window.location.host === 'point90-qr.premiere-cinemas.com') {
  url = 'https://point90-api.premiere-cinemas.com'
} else {
  url = 'http://localhost:3800'
}
export const URL_BASE = url



// WEBPACK FOOTER //
// ./src/helper/constants.js